.m-icon {
  // ENG-21740 Icon box sizes, not type-scale steps: an icon font sizes by font-size, and this
  // ramp must be free to move without dragging body text with it. Component-local on purpose.
  --m-icon-size-xs: 0.875rem;
  --m-icon-size-sm: 1.125rem;
  --m-icon-size-md: 1.5rem;
  --m-icon-size-lg: 2rem;
  --m-icon-size-xl: 2.875rem;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1em;
  height: 1em;
  flex-shrink: 0;
  font-size: 1em;
  line-height: 1;
  vertical-align: middle;
  // ENG-20860 match Quasar's .q-icon: content-box so padding on a padded icon
  // (e.g. a select dropdown chevron with m-px-sm) adds space instead of being
  // absorbed into the fixed 1em width.
  box-sizing: content-box;

  &--size-xs {
    font-size: var(--m-icon-size-xs);
  }

  &--size-sm {
    font-size: var(--m-icon-size-sm);
  }

  &--size-md {
    font-size: var(--m-icon-size-md);
  }

  &--size-lg {
    font-size: var(--m-icon-size-lg);
  }

  &--size-xl {
    font-size: var(--m-icon-size-xl);
  }
}
